import { ComponentSize } from '../../../types';

export const CHECKBOX_ICON_SIZE: Record<ComponentSize, number> = {
  [ComponentSize.X_SMALL]: 16,
  [ComponentSize.SMALL]: 20,
  [ComponentSize.MEDIUM]: 24,
  [ComponentSize.LARGE]: 32,
};
